import { render, staticRenderFns } from "./BeefGallery.vue?vue&type=template&id=3e81cbe1&scoped=true&"
import script from "./BeefGallery.vue?vue&type=script&lang=js&"
export * from "./BeefGallery.vue?vue&type=script&lang=js&"
import style0 from "./BeefGallery.vue?vue&type=style&index=0&id=3e81cbe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e81cbe1",
  null
  
)

component.options.__file = "BeefGallery.vue"
export default component.exports